import apiClient from '../client';

export interface PriceSheetMetadata {
  sheets: number[];
  trims: string[];
  priceCodes: string[];
  fabricNames: string[];
  tiers: number[];
}

export interface PriceSheetFilters {
  fabricName?: string;
  tier?: number;
}

export interface PriceSheetData {
  data: Record<string, number>;
  trimFabrics: Record<string, string>;
  trimTiers: Record<string, number>;
}

export const priceSheetService = {
  getMetadata: async (): Promise<PriceSheetMetadata> => {
    const response: any = await apiClient.get('/price-sheets/metadata');
    return response.data;
  },

  getSheetData: async (sheetName: number, filters?: PriceSheetFilters): Promise<PriceSheetData> => {
    const params: Record<string, string> = {};
    if (filters?.fabricName) params.fabricName = filters.fabricName;
    if (filters?.tier !== undefined) params.tier = filters.tier.toString();

    const response: any = await apiClient.get(`/price-sheets/${sheetName}`, { params });
    return response.data;
  },

  saveSheetData: async (
    sheetName: number,
    data: Record<string, number>,
    trimFabrics: Record<string, string>,
    trimTiers: Record<string, number>
  ): Promise<void> => {
    await apiClient.post(`/price-sheets/${sheetName}`, { data, trimFabrics, trimTiers });
  },
};
